import { IonPopover } from "@ionic/react";
import styled from "styled-components";
import { AlliePopoverProps } from "./Popover.types";

const getValueShadow = (value: boolean | string = true) => {
  if (typeof value === "boolean") {
    return value ? "0px 9px 12px rgba(9, 30, 66, 0.15)" : null;
  }
  return value;
};

export const StyledPopover: any = styled(IonPopover)<AlliePopoverProps>`
  --box-shadow: ${(props: AlliePopoverProps) => getValueShadow(props.shadow)};
`;
